import { SVGProps } from 'react'

export const SidebarIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill='none'
      height='20'
      viewBox='0 0 20 20'
      width='20'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g opacity='1'>
        <path
          d='M14.375 2.5C17 2.5 18.75 3.82387 18.75 6.91211V13.0879C18.75 16.1761 17 17.5 14.375 17.5H5.625C3 17.5 1.25 16.1761 1.25 13.0879V6.91211C1.25 3.82387 3 2.5 5.625 2.5H14.375ZM5.625 3.5C4.46797 3.5 3.65584 3.7914 3.13672 4.27734C2.62959 4.7522 2.25 5.55616 2.25 6.91211V13.0879C2.25 14.4438 2.62959 15.2478 3.13672 15.7227C3.65584 16.2086 4.46797 16.5 5.625 16.5H7.5V3.5H5.625ZM8.75 16.5H14.375C15.532 16.5 16.3442 16.2086 16.8633 15.7227C17.3704 15.2478 17.75 14.4438 17.75 13.0879V6.91211C17.75 5.55616 17.3704 4.7522 16.8633 4.27734C16.3442 3.7914 15.532 3.5 14.375 3.5H8.75V16.5Z'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}
